









































































































































































import Vue from "vue";
import { applyService } from "@/global/service/apply";
import loginService from "@/global/service/login";
import { CountDown } from "@/utils/countDown";
const countDown = new CountDown();
import axios from "axios";
import Cookie from "js-cookie";
const accountsList = `${process.env.VUE_APP_API}/api/hr/company/account-list`;
export default Vue.extend({
  data(): {
    form: CompanyInfo;
    formRules: SquareConfig;
    dialogVisible: boolean;
    dialogBtnLoading: boolean;
    innerVisible: boolean;
    accountList: SquareConfig[];
    btnLoading: boolean;
    schoolName: string;
    pageLoading: boolean;
    buttonName: string;
    time: number;
    errorBindData: string[];
    hasTOKEN: boolean;
  } {
    return {
      pageLoading: false,
      btnLoading: false,
      form: {
        code: "",
        contact: "",
        telephone: "",
        credit_code: "",
        company_name: "",
        company_account_ids: [],
      },
      dialogVisible: false,
      dialogBtnLoading: false,
      innerVisible: false,
      formRules: {
        company_name: [
          {
            required: true,
            message: "公司名称不为空",
            trigger: ["blur"],
          },
        ],
        credit_code: [
          {
            required: true,
            message: "请输入统一社会信用代码",
            trigger: ["blur", "change"],
          },
          {
            trigger: "blur",
            pattern: /^[^_IOZSVa-z\W]{2}\d{6}[^_IOZSVa-z\W]{10}$/g,
            message: "统一社会信用代码格式不正确",
          },
        ],
        contact: [
          {
            required: true,
            message: "联系人不为空",
            trigger: ["blur", "change"],
          },
        ],
        telephone: [
          {
            required: true,
            message: "联系电话不为空",
            trigger: ["blur", "change"],
          },
          {
            trigger: ["blur"],
            pattern: /^1(3[0-9]|4[57]|5[0-35-9]|7[0135678]|8[0-9])\d{8}$/,
            // /^1[3456789]\d{9}$/
            message: "联系电话格式不正确",
          },
        ],
        code: [
          {
            required: true,
            validator: this.checkCode,
            trigger: ["blur", "change"],
          },
        ],
      },
      accountList: [],
      buttonName: "获取验证码",
      time: 60,
      schoolName: "",
      errorBindData: [],
      hasTOKEN: false,
    };
  },
  computed: {
    code() {
      return this.$route.params.code;
    },
    bindBtnDisabled() {
      return Boolean(
        this.accountList.find((item: SquareConfig) => item.active)
      );
    },
  },
  created() {
    this.getSchoolInviteInfo();
  },
  methods: {
    checkCode(rule: any, value: string, cb: Function) {
      if (!value) {
        cb("请输入验证码");
      } else if (value.trim().length !== 6) {
        cb("请输入六位验证码");
      } else {
        cb();
      }
    },
    getSchoolInviteInfo() {
      this.pageLoading = true;
      applyService
        .getSchoolInviteInfo(this.code)
        .then((res: SquareConfig) => {
          this.schoolName = res.school_name;
          const token = Cookie.get("dock_company_token");
          if (token) {
            this.hasTOKEN = true;
            this.showAccountList();
          }
        })
        .finally(() => {
          this.pageLoading = false;
        });
    },
    getCode() {
      if (!this.isActive) {
        (this.$refs.formRef as any).validateField("telephone", (valid: any) => {
          if (!valid) {
            loginService.smsSend({ telephone: this.form.telephone });
            this.isActive = true;
            this.isDisabled = true;
            this.buttonName = this.time + "秒后重新发送";
            countDown.listen = ({ time = 0, status }: SquareConfig) => {
              if (status === "end") {
                this.buttonName = "获取验证码";
                this.time = 60;
                this.isActive = false;
                this.isDisabled = false;
                return;
              }
              this.time = time;
              const duration = Math.ceil(time / 1000) || 0;
              this.buttonName = duration + "秒后重新发送";
            };
            this.endTime = Date.now() + 1 * 60 * 1000;
            countDown.start(this.time * 1000, this.endTime);
          }
        });
      }
    },
    handleSubmit() {
      (this.$refs.formRef as any).validate((valid: boolean) => {
        if (valid) {
          this.btnLoading = true;
          let params = {
            telephone: this.form.telephone,
            code: this.form.code,
            type: 1, //登录类型1:企业，2:院校
          };
          loginService
            .getAccountList(params)
            .then((res: any) => {
              if (res.length === 0) {
                const params = this.form;
                this.submitInfo(params);
              } else if (res.length === 1) {
                this.accountList = res.map((item: SquareConfig) => {
                  item.active = true;
                  return item;
                });
                this.dialogVisible = true;
                this.btnLoading = false;
              } else {
                this.accountList = res.map((item: SquareConfig) => {
                  item.active = false;
                  return item;
                });
                this.dialogVisible = true;
                this.btnLoading = false;
              }
            })
            .catch(() => {
              this.btnLoading = false;
            });
        }
      });
    },
    submitInfo(arg: CompanyInfo) {
      this.dialogBtnLoading = true;
      let params = {} as CompanyInfo | InviteParam;
      const token = Cookie.get("dock_company_token");
      if (token) {
        const { company_account_ids } = arg;
        params = {
          company_account_ids,
          token,
        } as InviteParam;
      } else {
        params = arg as CompanyInfo;
      }
      applyService
        .agreeSchoolInvite(this.code, params)
        .then((res: SquareConfig) => {
          if (!res.success.length && res.error.length) {
            this.errorBindData = res.error;
            this.innerVisible = true;
          } else {
            this.$message.success("提交成功");
            if (
              Cookie.get("dock_company_token") &&
              params.company_account_ids.length
            ) {
              this.btnLoading = false;
              this.dialogBtnLoading = false;
              window.location.href =
                process.env.VUE_APP_HR_URL + `/company/partner`;
            } else {
              this.$router.push({
                name: "companyLogin",
              });
            }
          }
          this.dialogVisible = false;
        })
        .catch(() => {
          this.dialogVisible = token ? true : false;
        })
        .finally(() => {
          this.btnLoading = false;
          this.dialogBtnLoading = false;
        });
    },
    handleCooperation(type: string) {
      let params: CompanyInfo;
      params = this.form;
      if (type == "bind") {
        params.company_account_ids =
          this.accountList
            .filter((item) => item.active)
            ?.map((item) => item.id) || [];
      } else {
        params.company_account_ids = [];
      }
      this.submitInfo(params);
    },
    chooseAccount(item: SquareConfig) {
      const index = this.accountList.findIndex((account: SquareConfig) => {
        return item.id == account.id;
      });
      item.active = !item.active;
      this.accountList.splice(index, 1, item);
    },
    showAccountList() {
      const TOKEN = Cookie.get("dock_company_token");
      axios
        .get(accountsList, {
          headers: { Authorization: `Bearer ${TOKEN}` },
        })
        .then(({ data: { data: res } }: { data: { data: SquareConfig } }) => {
          this.accountList = res.map((item: SquareConfig) => {
            item.active = false;
            return item;
          });
          this.dialogVisible = true;
        });
    },
  },
});
